<div class="center ion-padding-top">
  <div class="error">
    <div class="container-img">
      <img class="image" src="assets/svg/icons8-binoculars.svg" width="100px" />
    </div>
    <p class="title-label">{{title}}</p>
  </div>
</div>